import PropTypes from 'prop-types';

export const AdminTaxEntryPropTypes = PropTypes.arrayOf(PropTypes.shape({
  periodName: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  activity: PropTypes.string.isRequired,
  typeDesc: PropTypes.string.isRequired,
  activityDesc: PropTypes.string.isRequired,
  allowTopside: PropTypes.string.isRequired,
  slAccount: PropTypes.string.isRequired,
  allowEntry: PropTypes.string.isRequired,
  slView: PropTypes.string.isRequired,
  allowTransfer: PropTypes.string.isRequired,
  slGlJournalExists: PropTypes.number.isRequired,
}));

export const ModalPropTypes = PropTypes.shape({
  show: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    type: PropTypes.string.isRequired,
    activity: PropTypes.string.isRequired,
  }),
});
